import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SnackbarComponentProps {
    open: boolean;
    message: string;
    severity?: 'success' | 'error' | 'warning' | 'info';
    autoHideDuration?: number;
    onClose: () => void;
}

const SnackbarComponent: React.FC<SnackbarComponentProps> = ({
    open,
    message,
    severity = 'success',
    autoHideDuration,
    onClose,
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Position on the left
        >
            <Alert
                severity={severity}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={onClose}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default SnackbarComponent;
